module.exports = __webpack_public_path__ + "static/media/gg.7beacfe4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gg.svg
// module id = 2097
// module chunks = 0